import * as React from "react";
import { useState } from "react";
import styled from "styled-components";
import { Panel, Button } from "components/bootstrap";
import { PaginatedEntityTable } from "components/common";
import { ModalProvider } from "common/contexts";
import AssetEntityActions from "security-app/components/Assets/AssetEntityActions";
import { columnRenderers } from "security-app/components/Assets/column-renderers";
import { withAssetAttributeFlags } from "security-app/components/Assets/constants";
import { useSearchAssets } from "security-app/hooks/useAssetsAPI";
import { scopeFiltersToEvent } from "./eventPreviewFilters";
const ToggleGroup = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
`;
const ENTITY_TABLE_ID = "asset_event_preview";
const PREVIEW_COLUMNS = {
  machine: [
    "name",
    "priority",
    "hostnames",
    "ip_addresses",
    "risk_score_normalized",
    "vulnerabilities",
    "mac_addresses"
  ],
  user: [
    "name",
    "priority",
    "usernames",
    "user_ids",
    "email_addresses",
    "risk_score_normalized",
    "first_name",
    "last_name"
  ]
};
const renderAssetActions = (asset) => /* @__PURE__ */ React.createElement(AssetEntityActions, { asset, readOnly: true });
const AssetEventPreviewTable = ({ config = void 0, assetType }) => {
  const { searchAssets, searchAssetsKeyFC } = useSearchAssets();
  const tableLayout = {
    entityTableId: ENTITY_TABLE_ID,
    layoutVariant: assetType,
    defaultPageSize: 5,
    defaultSort: { attributeId: "name", direction: "asc" },
    defaultDisplayedAttributes: PREVIEW_COLUMNS[assetType],
    defaultColumnOrder: PREVIEW_COLUMNS[assetType]
  };
  const keyFn = (searchParams) => [
    ...searchAssetsKeyFC(searchParams),
    "event-preview",
    assetType,
    config
  ];
  const fetchPreviewAssets = async (searchParams) => {
    const { filters, matchesNothing } = scopeFiltersToEvent(searchParams.filters, assetType, config);
    const response = withAssetAttributeFlags(await searchAssets({ ...searchParams, filters }), assetType);
    return matchesNothing ? { ...response, list: [], total: 0, pagination: { ...response.pagination, total: 0, count: 0 } } : response;
  };
  return /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName: "assets",
      keyFn,
      fetchEntities: fetchPreviewAssets,
      tableLayout,
      columnRenderers: columnRenderers[assetType],
      entityActions: renderAssetActions,
      entityAttributesAreCamelCase: false,
      withoutURLParams: true
    }
  );
};
const AssetEventPreview = ({ config }) => {
  const [assetType, setAssetType] = useState("machine");
  return /* @__PURE__ */ React.createElement(Panel, { header: /* @__PURE__ */ React.createElement("h3", null, "Asset Preview") }, /* @__PURE__ */ React.createElement("p", null, "Assets that would be targeted for risk threshold events by this event definition."), /* @__PURE__ */ React.createElement(ModalProvider, null, /* @__PURE__ */ React.createElement(ToggleGroup, null, /* @__PURE__ */ React.createElement(
    Button,
    {
      bsStyle: assetType === "machine" ? "primary" : "default",
      bsSize: "small",
      onClick: () => setAssetType("machine")
    },
    "Machines"
  ), /* @__PURE__ */ React.createElement(
    Button,
    {
      bsStyle: assetType === "user" ? "primary" : "default",
      bsSize: "small",
      onClick: () => setAssetType("user")
    },
    "Users"
  )), /* @__PURE__ */ React.createElement(AssetEventPreviewTable, { key: assetType, config: config.config, assetType })));
};
export default AssetEventPreview;
